import * as React from 'react';

class State {
}

class Props {
    id ?: string;
    show ?: boolean;
    className ?: string;
    main ?: boolean;
    flex ?: boolean;
    stretch ?: boolean;
}

function classList(props: Props, ...args: string[]) {
    let list = [];
    if (props.className) {
        list.push(props.className);
    }
    for (let i = 0; i < args.length; i++) {
        list.push(args[i]);
    }
    if (props.main) {
        list.push('content-main');
    }
    if (props.flex) {
        list.push('content-flex');
    }
    if (props.stretch) {
        list.push('stretch-vertical');
    }
    return list.join(' ');
}

const Content = {
    workspace: class Workspace extends React.Component <Props, State> {
        render() {
            return (
                <div className={classList(this.props, 'workspace')} id={this.props.id ? this.props.id : 'workspace'}>
                    <div className="content-page slide-in">
                        {this.props.children}
                    </div>
                </div>
            );
        }
    },

    page: class Page extends React.Component <Props, State> {
        render() {
            return (
                <div
                    className={classList(this.props, 'content-page slide-in')}
                    id={this.props.id ? this.props.id : 'workspace'}
                >
                    {this.props.children}
                </div>
            );
        }
    },

    row: class Row extends React.Component <Props, State> {
        getClasses() {
            return this.props.main
                ? 'content-main' + (this.props.flex ? ' content-flex' : '')
                : '';
        }

        render() {
            return (
                <div className={classList(this.props, 'content-row')} id={this.props.id ? this.props.id : 'workspace'}>
                    {this.props.children}
                </div>
            );
        }
    },

    leftbar: class LeftBar extends React.Component <Props, State> {
        render() {
            return (
                <div
                    className={classList(this.props, 'slide-left',
                                         this.props.show ? 'slide-left-open' : 'slide-left-close',
                                         'content-sidebar content-sidebar-left')}
                    id={this.props.id ? this.props.id : 'workspace'}
                >
                    {this.props.children}
                </div>
            );
        }
    }
};

export default Content;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/sys/content.tsx